<template>
	<div class="courseIntro">
		<div class="course_header">
			<div class="title">Class Details</div>
			<img src="../../assets/images/icon/close.png" @click="close" alt="">
		</div>
		<div class="course_detail">
			<div class="name">{{courseIntro.course_type_name}}</div>
			<div class="name">{{courseIntro.name}}</div>
			<div class="price_intro">{{courseIntro.introduction}} <span @click="toClassPack">click HERE for more info.</span> </div>
			<div class="price">One off Class:<span>£{{courseIntro.price}}</span></div>
		</div>
		<div class="intro_item flex align-center justify-between">
			<div class="name">For ages</div>
			<div class="val">{{courseIntro.course_age_name}}</div>
		</div>
		<div class="intro_item flex align-center justify-between">
			<div class="name">Offers Trial?</div>
			<div class="val">{{courseIntro.is_try == 0 ? 'No' : 'Yes'}}</div>
		</div>
		<div class="intro_item flex align-center justify-between">
			<div class="name">Term Dates</div>
			<div class="val">{{courseIntro.academic_system}}</div>
		</div>
		<div class="intro_item flex align-center justify-between">
			<div class="name">Class Capacity</div>
			<div class="val">{{courseIntro.num}}</div>
		</div>
		<div class="intro_item flex align-center justify-between">
			<div class="name">Venue</div>
			<div class="val">{{courseIntro.course_shop_name}}</div>
		</div>
		<div class="intro_item flex align-center justify-between">
			<div class="name">Classroom</div>
			<div class="val">{{courseIntro.class}}</div>
		</div>
		<div class="intro_item flex align-center justify-between">
			<div class="name">Class Date</div>
			<div class="val">{{courseIntro.start_date}} - {{courseIntro.end_date}}</div>
		</div>
		<!-- <div class="intro_item flex align-center justify-between">
			<div class="name">Class Time</div>
			<div class="val">{{courseIntro.start_time}}-{{courseIntro.end_time}}</div>
		</div> -->
		<div class="course_btn" @click="submitOrderByTry">Book</div>
		
	</div>
</template>

<script>
	export default{
		props:{
			courseIntro:{
				type:Object
			}
		},
		methods:{
			close(){
				this.$emit('close')
			},
			submitOrderByTry(){
				this.$emit('tyrCourse')
			},
			toClassPack(){
				this.$router.push('/home/classPack')
			},
		}
	}
</script>

<style lang="scss" scoped>
	.courseIntro{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		width: 750px;
		height: 80%;
		background: #F7F2EB;
		box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.2000);
		border-radius: 10px;
		padding: 0 30px 70px;
		overflow-y: scroll;
		.course_header{
			width: 100%;
			height: 88px;
			border-bottom: 1px solid #5C707A;
			position: relative;
			.title{
				font-size: 30px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #282E30;
				line-height: 88px;
			}
			img{
				width: 29px;
				height: 28px;
				position: absolute;
				right: 0;
				top: 50%;
				transform: translateY(-50%);
			}
		}
		.course_detail{
			padding-top: 40px;
			padding-bottom: 20px;
			.name{
				font-size: 22px;
				font-family: DIN;
				font-weight: 400;
				color: #282E30;
				line-height: 30px;
			}
			.price_intro{
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #C98B2C;
				margin-top: 20px;
				span{
					text-decoration: underline;
				}
			}
			.price{
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				margin-top: 20px;
				span{
					color: #BF5F49;
				}
			}
		}
		.intro_item{
			width: 100%;
			height: 63px;
			border-bottom: 1px solid #5C707A;
			padding: 0 30px 0 15px;
			.name{
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
			}
			.val{
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
			}
		}
		.course_btn{
			width: 182px;
			height: 58px;
			background: #5C707A;
			border-radius: 29px;
			margin: 77px auto 0;
			text-align: center;
			line-height: 58px;
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #F7F2EB;
		}
	}
</style>